import { Locale } from '@ps-smart-cp/ppfw-client';

const contractSearchConditionItemNameConfig = {
  allContracts: new Map([
    [Locale.ja, '全ての契約'],
    [Locale.en, 'All Contracts'],
  ]),
  contractPaymentCurrentMonth: new Map([
    [Locale.ja, '当月に支払いがある契約'],
    [Locale.en, 'Contracts with a Payment in the Current Month'],
  ]),
  contractExpireCurrentMonth: new Map([
    [Locale.ja, '当月に満了する予定の契約'],
    [Locale.en, 'Contracts Due to Expire in the Current Month'],
  ]),
  contractExpireCurrentMonthRegReLease: new Map([
    [Locale.ja, '当月に満了する予定の契約のうち、再リース及び契約満了の登録がされている契約'],
    [Locale.en, 'Contracts Expire on the Current Month with Registered Re-lease and Contract Expiration'],
  ]),
  contractExpireCurrentMonthNoRegReLease: new Map([
    [Locale.ja, '当月に満了する予定の契約のうち、再リース及び契約満了の登録がされていない契約'],
    [Locale.en, 'Contracts Expire on the Current Month with No Registered Re-lease and Contract Expiration'],
  ]),
  contractExpirationNotificationTarget: new Map([
    [Locale.ja, '契約満了通知の対象と合致する契約'],
    [Locale.en, 'Contracts Matching Contract Expiration Notification Target'],
  ]),
} satisfies Record<string, Map<Locale, string>>;

export { contractSearchConditionItemNameConfig };
